export function scrollTab(tabcontent_id) {
    var ziel = $(tabcontent_id);
    var top = ziel.offset().top;
    var heightTabnavi = $('#sticky-tab > div > ul').outerHeight();
    $('html,body').animate({
        scrollTop: top - heightTabnavi
    }, 800);
}
